import { HttpClient } from '@angular/common/http';
import { inject } from '@angular/core';
import { Observable } from 'rxjs';
import { Page, SearchRequest } from '../model';

export interface Crud<T> {
  get(id: string | number): Observable<T>;
  create(data: unknown): Observable<T>;
  update(value: T): Observable<T>;
  delete(value: T): Observable<void>;
}

export abstract class Crud<T> {
  protected abstract baseUrl: string;
  http = inject(HttpClient);
  abstract search(request: SearchRequest): Observable<Page<T>>;
}
